<template lang="pug">
b-dropdown.field-type-select(
  :expanded="expanded"
  :value="value"
  @change="change"
)
  a.button.is-fullwidth(slot="trigger")
    b-icon(:icon="type.icon")
    span {{ type.label }}
  b-dropdown-item(
    v-for="t in types"
    :key="t.key"
    :value="t.key"
  )
    article.media
      figure.media-left
        b-icon(:icon="t.icon")
      .media-content
        b {{ t.label }}
        br
        small.has-text-grey {{ t.description }}
</template>

<script>
import _ from 'lodash';
import { HTTP } from '@/utils/http';

export default {
  name: 'field-type-select',
  async created() {
    const { data } = await HTTP.get('/form_fields/field_types', {});
    this.types = data.data.types;
    if (this.value) {
      this.type = _.find(this.types, { key: this.value });
    }
  },
  data() {
    return {
      key: null,
      type: {},
      types: [],
    };
  },
  methods: {
    change(val) {
      this.$emit('input', val);
      this.type = _.find(this.types, { key: val });
    },
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
  },
  watch: {
    value(key) {
      this.type = _.find(this.types, { key });
    },
  },
};
</script>

<style lang="scss">
.field-type-select {
  width: 100%;
  .dropdown-trigger {
    width: 100%;
    .button {
      justify-content: flex-start;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/FieldTypeSelect.vue